import { Location } from 'history'
import React from 'react'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import LogsComponent from '@/app/module/logs'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  location: Location
  match: MatchProps
}

const Logs = LogsComponent as React.FC<any>

export default function LogsPage(props: Props) {
  const { match } = props
  const params = new URLSearchParams(props.location.search)

  const tab = params.get('tab')
  React.useEffect(() => {
    if (!tab) {
      return
    }

    switch (tab) {
      case 'messages':
        window.document.title = 'Message Logs - engageSPARK'
        break
      case 'calls':
        window.document.title = 'Call Logs - engageSPARK'
        break
      case 'whatsapp':
        window.document.title = 'WhatsApp Logs - engageSPARK'
        break
      case 'topups':
        window.document.title = 'Top-up Logs - engageSPARK'
        break
      default:
        window.document.title = 'Logs - engageSPARK'
        break
    }
  }, [tab])

  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Logs - engageSPARK">
        <AuthHeader currentPage={PAGE.LOGS.INDEX} />
        <TotpGuard>
          <Logs
            search={params.get('search') ? decodeURIComponent(params.get('search')!) : ''}
            type={params.get('type')}
            status={params.get('status')}
            tab={params.get('tab')}
            to={params.get('to')}
            from={params.get('from')}
          />
        </TotpGuard>
      </Layout>
      <Notifications />
    </AuthGuard>
  )
}
